import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    horizontalLine: {
        borderBottom: `1px solid ${theme.palette.corporateBO.buttonLineDivider}`,
        flexGrow: 1,
    },
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "0 22px 22px 22px",
    },
    buttonContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "15px 0",
    },
    addProductionLineButton: {
        "&.MuiButtonBase-root": {
            color: theme.palette.info.main,
            fontWeight: 700,
            fontSize: "12px",
            fontFamily: "Open Sans",
        },
        gap: theme.spacing(2),
    },
    moreIcon: {
        color: theme.palette.info.main,
        fontWeight: 400,
    },
    addProductionLineButtonText: {
        fontSize: "12px !important",
    },
}));
